import React, { Component } from 'react';

export class Dashboard extends Component {
    static displayName = Dashboard.name;

    render() {
        return (
            <div>
                <h1>Hallo, Nutzer!</h1>
                <span>&nbsp;&nbsp;</span>
                <h3>Neuigkeiten: </h3>
                <p>Momentan gibt es keine Neuigkeiten.</p>
            </div>
        );
    }
}
